import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  requiredstep: string;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredstep, children }) => {
  const auth= localStorage.getItem("auth");
  const token= localStorage.getItem("token");
  return auth=== requiredstep ? (
    <>{children}</>
  ) : (
    // token ? <Navigate to='/dashboard' replace/>:
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
